import { apiClient } from "./client";
import { User } from "../types";

export interface LoginResponse {
  token: string;
  user: User;
  /** Permessi effettivi (default del ruolo + override per-utente). Pilotano menu e route guard. */
  permissions: string[];
  must_change_password: boolean;
}

// `identifier` può essere un'email oppure un numero di telefono: il backend
// distingue dal formato. Il campo `email` non viene più inviato.
export async function login(identifier: string, password: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>("/auth/login", { identifier, password });
  return data;
}

export interface RegisterPayload {
  token: string;
  password: string;
  /** Facoltativo: assente per gli account aziendali non intestati a una persona. */
  full_name?: string;
  /** Facoltativo: es. "Amministrazione", "Sede di Milano". */
  riferimento?: string;
}

export async function register(
  payload: RegisterPayload
): Promise<{ token: string; user: User; permissions: string[] }> {
  const { data } = await apiClient.post<{ token: string; user: User; permissions: string[] }>(
    "/auth/register",
    payload
  );
  return data;
}

export async function refresh(): Promise<{ token: string }> {
  const { data } = await apiClient.post<{ token: string }>("/auth/refresh");
  return data;
}

export async function me(): Promise<{ user: User; permissions: string[] }> {
  const { data } = await apiClient.get<{ user: User; permissions: string[] }>("/auth/me");
  return data;
}

export async function updateMe(payload: { full_name?: string }): Promise<{ user: User }> {
  const { data } = await apiClient.patch<{ user: User }>("/auth/me", payload);
  return data;
}

/**
 * Il token in risposta sostituisce quello corrente: il cambio invalida tutti i
 * token emessi prima, compreso quello con cui è partita questa richiesta.
 */
export async function changePassword(
  current_password: string,
  new_password: string
): Promise<{ success: true; token: string }> {
  const { data } = await apiClient.post<{ success: true; token: string }>("/auth/change-password", {
    current_password,
    new_password,
  });
  return data;
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>("/auth/forgot-password", { email });
  return data;
}

export async function resetPassword(token: string, password: string): Promise<{ success: true }> {
  const { data } = await apiClient.post<{ success: true }>("/auth/reset-password", { token, password });
  return data;
}
